// extracted by mini-css-extract-plugin
export var chip = "_dz-0";
export var filterDropdown = "_dz-5";
export var filterItem = "_dz-6";
export var icon = "_dz-1";
export var removeButton = "_dz-3";
export var removeIcon = "_dz-4";
export var separator = "_dz-2";